import {
	CONST_INSTRUCTED,
	CONST_EQUIVALENT,
	CONST_GBP_EQUIVALENT,
	CONST_AMOUNT_UPPERCASE,
} from '../../../../../src/constants/Constants';
import { TYPE_IFT } from '../../../../../src/config';

const hardTokenLiveRateVerification = [
	{
		verification_id: '12337855-f07c-4298-80c6-9f5a9a5e123468ea',
		status: 'PENDING',
		created_timestamp: '2021-10-15T00:00:00.000Z',
		final_approval: true,
		verification_type: 'HARD',
		ift: {
			payment_uuid: '12337855-f07c-4298-80c6-9f5a9a5e123468ea',
			type: TYPE_IFT,
			amount: '145.50',
			currency: 'GBP',
			debtor_currency: 'GBP',
			creditor_currency: 'EUR',
			creator_id: '0112341234',
			creator_name: 'John Brown',
			payment_amount: [
				{
					type: CONST_INSTRUCTED,
					value: '140.00',
					currency: 'EUR',
				},
				{
					type: CONST_EQUIVALENT,
					value: '145.50',
					currency: 'GBP',
				},
				{
					type: CONST_GBP_EQUIVALENT,
					value: '145.50',
					currency: 'EUR',
				},
			],
			approvers: [
				{
					approver: 'Lisa McDonald',
					status: 'PENDING',
				},
				{
					approver: 'George Bowman',
					status: 'VERIFIED',
				},
			],
			from_account: {
				account_number: '12345678',
				name: 'Current Account', // Currently sent as null
				sort_code: '822000', // Optional for Kapiti accounts
			},
			to_account: {
				account_number: '', // Not used for international accounts
				iban: 'abcdefghijklmnopqrstuvwxyz12345678', // 34 characters, alphanumeric
				name: 'Veronica Duncan', // Currently sent as null
				bic: '', // optional, will either get this or bank when user sends target_account
				bank: {
					// optional, will either get this or bic when user sends target_account
					name: '',
					address: {
						address_line_1: '',
						address_line_2: '',
						city: '',
						postal_code: '',
						country: '',
					},
				},
				beneficiary_address: {
					// payee customer address
					address_line_1: '',
					address_line_2: '',
					city: '',
					postal_code: '',
					country: '',
				},
				clearing_code: '', // optional
			},

			reference: 'A payment for XYZ', // optional
			value_date: '2021-10-10',
			submission_date: '2021-10-10',
			urgent: true,
			charging_model: 'CRED', // optional
			indicative_fx: {
				rate: '0.8455',
				type: 'LIVE',
			},
			charge_amount: [
				{
					type: CONST_AMOUNT_UPPERCASE,
					value: '5.00',
					currency: 'EUR',
				},
				{
					// only when non GBP amount
					type: CONST_GBP_EQUIVALENT,
					value: '5.50',
					currency: 'GBP',
				},
			],
		},
	},
	{
		verification_id: '12337855-f07c-4298-80c6-9f5a9a5e123455de',
		status: 'PENDING',
		created_timestamp: '2021-10-15T00:00:00.000Z',
		final_approval: true,
		verification_type: 'HARD',
		ift: {
			payment_uuid: '12337855-f07c-4298-80c6-9f5a9a5e123455de',
			type: TYPE_IFT,
			amount: '123.23',
			currency: 'EUR',
			debtor_currency: 'EUR',
			creditor_currency: 'EUR',
			creator_id: '0112341234',
			creator_name: 'John Brown',
			payment_amount: [
				{
					type: CONST_INSTRUCTED,
					value: '123.23',
					currency: 'EUR',
				},
				{
					type: CONST_EQUIVALENT,
					value: '123.23',
					currency: 'GBP',
				},
				{
					type: CONST_GBP_EQUIVALENT,
					value: '123.23',
					currency: 'EUR',
				},
			],
			approvers: [
				{
					approver: 'Lisa McDonald',
					status: 'PENDING',
				},
				{
					approver: 'George Bowman',
					status: 'VERIFIED',
				},
			],
			from_account: {
				account_number: '12345678',
				name: 'Current Account', // Currently sent as null
				sort_code: '822000', // Optional for Kapiti accounts
			},
			to_account: {
				account_number: '', // Not used for international accounts
				iban: 'abcdefghijklmnopqrstuvwxyz12345678', // 34 characters, alphanumeric
				name: 'Linda Murray', // Currently sent as null
				bic: '', // optional, will either get this or bank when user sends target_account
				bank: {
					// optional, will either get this or bic when user sends target_account
					name: '',
					address: {
						address_line_1: '',
						address_line_2: '',
						city: '',
						postal_code: '',
						country: '',
					},
				},
				beneficiary_address: {
					// payee customer address
					address_line_1: '',
					address_line_2: '',
					city: '',
					postal_code: '',
					country: '',
				},
				clearing_code: '', // optional
			},

			reference: 'A payment for ABC', // optional
			value_date: '2022-01-14',
			submission_date: '2022-01-14',
			urgent: true,
			charging_model: 'CRED', // optional
			indicative_fx: {
				rate: '0.8455',
				type: 'LIVE',
			},
			charge_amount: [
				{
					type: CONST_AMOUNT_UPPERCASE,
					value: '5.00',
					currency: 'EUR',
				},
				{
					// only when non GBP amount
					type: CONST_GBP_EQUIVALENT,
					value: '5.50',
					currency: 'GBP',
				},
			],
		},
	},
];

export { hardTokenLiveRateVerification };
